import { SignupForm } from '@/platform/auth/signup-form';
import { AmbientBackground } from '@/platform/ui/ambient-background';

export default function SignupPage() {
  return (
    <>
      <AmbientBackground />
      <div className="flex min-h-screen items-center justify-center p-4">
        <SignupForm />
      </div>
    </>
  );
}
